export enum EnumOrganizationAccessLevels {
    None = 'None',
    Read = 'Read',
    Full = 'Full',
}
